import axios, { AxiosRequestConfig } from "axios";
import useAuth from "../hooks/useAuth";

const BASE_URL = process.env.REACT_APP_API_URI;

export const api = axios.create({
  baseURL: BASE_URL,
});

api.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const { getToken } = useAuth();
    const token = getToken();

    if (token) {
      config.headers = {
        Authorization: `Bearer ${token}`,
      };
    }

    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

api.interceptors.response.use(
  (_res) => _res,
  (err) => {
    const { status, data } = err?.response;

    // Redirect unauthorized users to login page
    if (status === 401) {
      const msg = data?.msg;
      const pathName = window.location.pathname;
      const freeRoutes = [
        "/login",
        "/signup",
        "/password-recovery",
        "/reset-password",
      ];

      const isFreeRoute = freeRoutes.includes(pathName);

      if (msg === "unauthorized" && !isFreeRoute) {
        localStorage.clear();
        window.location.replace("/login");
      }
    } //Redirect limited by plan user.
    else if (status === 400) {
      const msg = data?.msg;

      if (msg === "Limit reached") {
        const resource = data?.resource;

        window.location.replace(`/usage-limit/${resource}`);
      }
    } else if (status === 403) {
      const msg = data?.msg;

      if (msg === "Only for premium users") {
        localStorage.removeItem("is_premium_valid");
        window.location.replace("/welcome");
      }
    } else if (status === 406) {
      const msg = data?.msg;

      if (msg === 'Asset type not supported (FIIS)') {
        window.location.replace("/unsupported-fiis");
      }
    }

    return Promise.reject(err);
  }
);
